export const repeat = ({ time = 5000, action }) => {
  return setInterval(() => {
    action();

    return 1;
  }, time);
};
